module.exports = "/fonts/vendor/primeicons/primeicons.ttf?ea5358601d0a3fd6670b3d7e757fd288";